import * as Models from "../ts/rlAdmin.models";
import { EntityConfigService } from "../services/entity-config-service";
import { EntityService } from "../services/entity-service";

RLReportParamPickerModal.$inject = ["$timeout"];
export function RLReportParamPickerModal($timeout: ng.ITimeoutService) {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/report-param-picker-modal.html"),
        controller: RLReportParamPickerModalController,
        controllerAs: "rppmVM",
        scope: {
            paramKey: "=rlReportParamPickerModal",
            paramOutput: "=",
            paramDisplay: "=",
            modalOpen: "=",
            mode: "=?",
            allowMultiple: "=?"
        },
        bindToController: {

        },
        require: "rlReportParamPickerModal",
        link: (scope: IRLReportParamPickerModalScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLReportParamPickerModalController) => {
        }
    };
    return directive;
}

interface IRLReportParamPickerModalScope extends ng.IScope {
    paramKey: string;
    paramOutput: string;
    paramDisplay: string;
    modalOpen: boolean;
    mode: string;
    allowMultiple: string;
}

class RLReportParamPickerModalController {
    static $inject = ["$scope", "entityConfigService", "entityService", "$q", "$timeout"];
    mode: string;
    modalStyle: string;
    selectedIndicator: string;
    selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];
    showColumns: string[];
    canCreate: boolean;
    allowMultiple: boolean;
    isDisabled: boolean;
    showAdvance: boolean;

    paramOutputUnapplied: string;
    paramDisplayUnapplied: string;

    shouldSave: boolean = false;        // signal from the param picker to save
    shouldReset: boolean = false;       // signals the param picker to reset itself

    constructor(private $scope: IRLReportParamPickerModalScope, private entityConfigService: EntityConfigService, private entityService: EntityService, private $q: ng.IQService, private $timeout: ng.ITimeoutService) {

        this.mode = "";
        this.canCreate = false;
        this.allowMultiple = $scope.$eval($scope.allowMultiple) || false;
        this.isDisabled = false;
        this.showAdvance = this.allowMultiple;

        // modal
        this.paramOutputUnapplied = this.$scope.paramOutput;
        this.paramDisplayUnapplied = this.$scope.paramDisplay;

        $scope.$watch(() => this.shouldSave, (newValue, oldValue) => {
            if (newValue) {
                this.shouldSave = false;
                this.Save();
            }
        });

        $scope.$watch(() => this.mode, (newValue, oldValue) => {
            $scope.mode = this.mode;
        });

        $scope.$watch(() => this.$scope.paramOutput, (newValue, oldValue) => {
            this.paramOutputUnapplied = this.$scope.paramOutput;
        });

        //$scope.$watch(() => $scope.modalOpen,
        //    (newValue, oldValue) => {
        //        if (newValue !== oldValue) {
        //            if (newValue !== false) {
        //                this.shouldReset = true;
        //            }
        //        }
        //    }, true);
    }

    Cancel() {
        this.paramOutputUnapplied = this.$scope.paramOutput;
        this.paramDisplayUnapplied = this.$scope.paramDisplay;
        this.shouldReset = true;
        return;
    }

    Save() {
        this.$scope.paramOutput = this.paramOutputUnapplied;
        this.$scope.paramDisplay = this.paramDisplayUnapplied;
        return;
    }
}
